import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { Inject, PLATFORM_ID } from '@angular/core';
import { BusinessInfo } from '@app/model/business-info';
import { FeedRating } from '@app/model/feedsRating';
import { BusinessDetailsService } from '@app/services/BusinessDetails/businessDetails.service';
import { FeedsService } from '@app/services/feeds/feeds.service';
import { environment } from '../../../../../environments/environment.prod';
import { SafeUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-business-card',
  templateUrl: './business-card.component.html',
  styleUrls: ['./business-card.component.scss']
})
export class BusinessCardComponent implements OnInit {

  userInfoId: any;
  profileImageURL: any;
  businessImageURL: any;

  feedList: any;
  feedTotal: any;
  feedAvg: any;

  @Input('businessData') business!: BusinessInfo;

  serverImgUrl = environment.IMG_URL;
  serverUrl = environment.PRO_URL;
  isBrowser: boolean;
  
  constructor(
    private businessService: BusinessDetailsService, 
    private feedsService: FeedsService,
    @Inject(PLATFORM_ID) platformId: object) {
    this.isBrowser = isPlatformBrowser(platformId);
  }

  //For toggle hide show
  addRemoveClass: boolean = false;

  clickEvent() {
    this.addRemoveClass = !this.addRemoveClass;
  }
  
 // This is for transfer click event value to parent component. ******
  ngOnInit() {
    if (this.business && this.business.userInfoId) {
      this.userInfoId = this.business.userInfoId;
      this.fetchProfileImgById();
      this.fetchSliderProductImgById();
      this.fetchFeedsByBusinessUUID();
    }
  }
  
  setUserId(id: string): void {
    localStorage.setItem('bId', id);
  }

  mapModalEvent(latitude:any, longitude:any, cName:any){
    // Below code to open model - start
    const modelDiv = document.getElementById('myMapModel');
    const modelBackdropDiv = document.getElementById('modalBackdrop');
    if(modelDiv != null && modelBackdropDiv != null) {
      modelDiv.style.display = 'block';
      modelDiv.classList.add("show");
      modelBackdropDiv.classList.add("show");
    }
    // End model code


    //shorthand is below
    //this.mapEvent.emit({googleLatitude:latitude, googleLongitude:longitude, businessName:cName});
    const mapLatitude = document.getElementById('mapLatitude');
    const mapLongitude = document.getElementById('mapLongitude');
    const mapName = document.getElementById('mapName');
    
    if(mapName!=null && mapLatitude!=null && mapLongitude!=null)
    {
      mapName.innerHTML = cName;  ;
      mapLatitude.innerHTML = longitude;
      mapLongitude.innerHTML = latitude;
    }
  }

  enquiryModalEvent(userInfoId:any){
    // Below code to open model - start
    const modelDiv = document.getElementById('myEnquiryModel');
    const modelBackdropDiv = document.getElementById('modalBackdrop');
    //const emailID = document.getElementById('sendEnquiryButton')?.appendChild() = this.userEmail.email;
    
    if(modelDiv != null && modelBackdropDiv != null) {
      modelDiv.style.display = 'block';
      modelDiv.classList.add("show");
      modelBackdropDiv.classList.add("show");
    }
    // End open model 
    // get user email id and send to enquiry form
    this.setUserId(userInfoId as any);
    console.log(userInfoId);
    // this email id assign to app-send-enquiry.component save button
  } 
  // End ******

  // Below API return profile images
  fetchProfileImgById() {
    this.businessService.getProfileImgByUUId(this.business.userInfoId).subscribe({
      next: (res: any) => {
        const user = res.data.find((user: any) => user.userInfoId === this.business.userInfoId);
        if (user) {
          const imageURL = user.profileImageURL;
          this.profileImageURL = `${this.serverImgUrl}profiles/${imageURL}`;
        } else {
          this.profileImageURL = `../../assets/images/all/1.jpg`;
        }
      }
    })
  }

  // Below API return product images
  fetchSliderProductImgById() {
    this.businessService.getSliderImageByUUId(this.business.userInfoId).subscribe({
      next: (res: any) => {
        const user = res.data.find((user: any) => user.userInfoId);
        if (user) {
          const imageURL = user.businessImageURL;
          this.businessImageURL = `${this.serverImgUrl}sliderImages/${imageURL}`;
        } else {
          this.businessImageURL = `../../assets/images/all/1.jpg`;
        }
      }
    })
  }

  // Below API return business feeds
  fetchFeedsByBusinessUUID(): void {
    this.feedsService.fetchFeedsByBusinessUUID(this.userInfoId)
      .subscribe({
        next: (p) => {
          this.feedList = p as FeedRating;
          this.feedTotal = this.feedList.data.length;
          var sum = 0;
          if (this.feedList.data != null && this.feedList.data.length > 0) {
            for (var i = 0; i < this.feedList.data.length; i++) {
              sum += this.feedList.data[i].feedRating;
            }
            this.feedAvg = sum / this.feedList.data.length;
          }
          else {
            this.feedAvg = 0;
          }
        }
      });
  }

  // Set URL for QRCODE to search product 
  qrCodeDownloadLink: SafeUrl = "";
  qrCodeString(){
    return `${this.serverUrl}/business-details/${this.getHyphenatedString()}`;
  }

  onChangeURL(url: SafeUrl) {
    this.qrCodeDownloadLink = url;
  }

  // Set name for SEO URL 
  limitedTitle :any;
  getHyphenatedString() {
    this.limitedTitle = this.business.businessName || '';
    return this.limitedTitle
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }
}
